import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid, TextField,
} from '@material-ui/core';

export const testId = 'tid';

export function PasswordImpl({
  value, setValue, placeholder, error,
}) {
  return (
    <Grid item xs={12}>
      <TextField
        required
        value={value}
        onChange={(e) => setValue(e.target.value)}
        type="password"
        name="password"
        placeholder={placeholder}
        style={{
          width: '100%',
        }}
        label=""
        error={error}
        data-test={testId}
      />
    </Grid>
  );
}

PasswordImpl.propTypes = {
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default (PasswordImpl);
